import { Countly } from 'modules/countly';
import { createContext } from 'react';

export interface CaptureCountlyEvents {
    addCountlyEvent: typeof Countly.addEvent;
}

const CaptureCountlyEventsContext = createContext<CaptureCountlyEvents | undefined>(undefined);

CaptureCountlyEventsContext.displayName = 'CaptureCountlyEventsContext';

export { CaptureCountlyEventsContext };
